import request from '../../request';

export default {
  actions: {
    // list all services
    getServices(_, parameters) {
      return request.get('services', {
        params: parameters,
      });
    },
    getSaleServices(_, parameters) {
      return request.get('get-sale-services');
    },
    postSale(_, payload) {
      return request.post('processes', payload);
    },
    getLastProcess(_) {
      return request.get('last-process');
    },
    tailorList(_, payload) {
      return request.get('tailor-list', {
        params: payload,
      });
    },
    getProcessById(_, id) {
      return request.get('get-process-by-id/' + id);
    },

    getOnlyServices(_) {
      return request.get('get-only-services');
    },

    getLeasedProducts(_, payload) {
      return request.get('get-leased-products', {
        params: payload,
      });
    },
    getLeasedProductsInfo(_, payload) {
      return request.get('get-leased-products-info', {
        params: payload,
      });
    },

    getDashboard(_) {
      return request.get('dashboardData');
    },

    getTailorProducts(_, filterType) {
      return request.get('get-tailor-products', {
        params: {
          filterType,
        },
      });
    },

    getDryProducts(_, filterType) {
      return request.get('get-dry-products', {
        params: {
          filterType,
        },
      });
    },

    getDeletedServices() {
      return request.get('deleted-services');
    },

    getLeasesByService(_, payload) {
      return request.get('leases-by-product/' + payload);
    },

    leaseAction(_, payload) {
      return request.post('lease-product', payload);
    },

    createPayment(_, payload) {
      return request.post('create-payment-for-lease', payload);
    },

    getContract(_, id) {
      return request.get('get-contract/' + id);
    },

    release(_, payload) {
      return request.post('release', payload);
    },

    releaseTailor(_, payload) {
      return request.post('releaseTailor', payload);
    },
    releaseDry(_, payload) {
      return request.post('releaseDry', payload);
    },

    // create new service
    createService(_, payload) {
      return request.post('services', payload);
    },

    createServiceVSelect(_, payload) {
      return request.post('services?response=vselect', payload);
    },

    // update service
    updateService(_, payload) {
      return request.put('services/' + payload.id, payload.service);
    },

    // delete service
    deleteService(_, id) {
      return request.delete('services/' + id);
    },

    deleteCompService(_, id) {
      return request.delete('services/delete/' + id);
    },

    createBarcodeHTML(_, barcode) {
      return request.get('barcode-generator/' + barcode);
    },

    getSurplusProducts(_, payload) {
      let { page, ...pl } = payload;
      return request.post('surplusproducts?page=' + page, payload);
    },

    deleteAllSurpluses(_, payload) {
      return request.post('deleteallsurpluses', payload);
    },
  },
};
